import service from '@/utils/request'

// 授权列表分页查询（companyUuid 必传）
export const page = (params: any) =>
  service.request({
    method: 'post',
    url: '/carBusinessAuth/page',
    data: params
  })

// 授权流水分页查询（companyUuid 必传）
export const logPage = (params: any) =>
  service.request({
    method: 'post',
    url: '/carBusinessAuth/logPage',
    data: params
  })

// 违约强制关闭（按公司+外部合同编号+业务类型批量关闭生效授权）
export const forceCloseByContract = (params: any) =>
  service.request({
    method: 'post',
    url: '/carBusinessAuth/forceCloseByContract',
    data: params
  })
